export default __webpack_public_path__ + "static/media/search_icon.3f1e7b4f.svg";